import { useRouter } from "next/router";
import {
  User,
  useGetConnectReferrerInfoQuery,
  useGetUserQuery,
} from "../graphql/generated/graphql";
import { useSession } from "next-auth/react";
import { isInactive, isUnauthorized } from "../utils/connect";

export default function useGetSellerInfo({
  seller,
  isContactInfoPublic,
}: {
  seller: User;
  isContactInfoPublic?: string | boolean;
}) {
  const router = useRouter();
  const { "connect-ref": connectRef } = router.query;
  const { status: sessionStatus } = useSession();

  const { data: getReferrerSellerData, loading: loadingReferrerSellerInfo } =
    useGetConnectReferrerInfoQuery({
      variables: {
        username: connectRef as string,
      },
      skip: !connectRef,
    });

  const { getConnectReferrerInfo: getReferrerSellerContact } =
    getReferrerSellerData || {};

  const { data: getOriginalSellerData, loading: loadingOriginalSellerInfo } =
    useGetUserQuery({
      variables: {
        _id: seller._id,
      },
      skip:
        (sessionStatus === "unauthenticated" && !isContactInfoPublic) ||
        loadingReferrerSellerInfo,
    });

  const { getUser: getOriginalSellerContact } = getOriginalSellerData || {};

  let sellerInfo = getOriginalSellerContact || seller;
  if (
    !loadingReferrerSellerInfo &&
    !getReferrerSellerContact &&
    sessionStatus === "unauthenticated" &&
    !isContactInfoPublic
  ) {
    return {
      sellerInfo,
    };
  }

  if (
    !isUnauthorized(getOriginalSellerContact) &&
    !isInactive(getOriginalSellerContact) &&
    getReferrerSellerContact
  ) {
    sellerInfo = getReferrerSellerContact;
  }

  return {
    loading: loadingReferrerSellerInfo || loadingOriginalSellerInfo,
    sellerInfo,
  };
}
